import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import type { IcmLineItem } from "@/icm/types";

const PayoutAmountCol = (): ColumnDef<IcmLineItem> => ({
  accessorKey: "payout_amount",
  header: "Payout",
  meta: { size: "120px" },
  cell: ({ getValue }) => formatMoney(getValue() as string) ?? "-",
});

export default PayoutAmountCol;
